const api_end_point = "https://api.futureenergyasia.com/umbraco/surface/ExhibitorList/";
//const api_end_point = "http://localhost:8080/umbraco/surface/ExhibitorList/";
const api_end_point_wuc = "https://marketingmanual.worldutilitiescongress.com/umbraco/surface/exhibitorlist/";
//const api_end_point = "https://stage.exlist.s.cmshelp.dk/umbraco/surface/ExhibitorList/";
//const api_end_point = "http://localhost:8001/umbraco/surface/ExhibitorList/";

export default {
  country_list_api: (eventname) => `${api_end_point}GetCountriesListall?eventName=${eventname}`,
  product_list_api: (eventname) => `${api_end_point}GetProductCategoriesListAll?eventName=${eventname}`,
  initial_load_api: (eventname) => `${api_end_point}GetAllExhibitorsAll?eventName=${eventname}`,
  filter_list_api: api_end_point + "GetFilteredDataAll",
  exhibitor_detail_api: api_end_point + "GetExhibitorByIdAll",

  /*for wuc*/
  initial_load_api_WUC: api_end_point_wuc + "getallexhibitors",
  exhibitor_detail_api_WUC: api_end_point_wuc + "GetExhibitorById",
  country_list_api_WUC: api_end_point_wuc + "GetCountriesList",
  product_list_api_WUC: api_end_point_wuc + "GetProductCategoriesList",
  filter_list_api_WUC: api_end_point_wuc + "GetFilteredData",
};
